/* kravaritis.com: γρήγορη προσθήκη στο καλάθι από τις κάρτες και πρόσθετα προϊόντος */
(function () {
  function addToCart(items, button) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) { alertMessage(button, res.description); return; }
        if (drawer && res.sections) {
          res.id = items[0].id;
          drawer.renderContents(res);
          drawer.classList.remove('is-empty');
          try { if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init(); } catch (e) {}
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (button) { button.removeAttribute('aria-busy'); button.disabled = false; } });
  }
  function alertMessage(button, msg) {
    if (!button) return;
    var p = button.parentElement.querySelector('.krv-err');
    if (!p) { p = document.createElement('p'); p.className = 'krv-err'; p.setAttribute('role', 'alert'); button.parentElement.appendChild(p); }
    p.textContent = msg;
  }
  window.krvAddToCart = addToCart;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-krv-quick-add]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    addToCart([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }], form.querySelector('[type=submit]'));
  });
})();

/* Αναζήτηση μέσα στα μεγάλα φίλτρα (π.χ. Μάρκα): κουτάκι που κρύβει όσες τιμές δεν ταιριάζουν */
(function () {
  function norm(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function setup(root) {
    root.querySelectorAll('details.js-filter').forEach(function (d) {
      var list = d.querySelector('ul.facets__list--vertical, ul.mobile-facets__list');
      if (!list || list.querySelector('.krv-facet-search')) return;
      var items = list.querySelectorAll(':scope > li');
      if (items.length < 8) return;
      var title = ((d.querySelector('summary') || {}).textContent || '').trim().split('\n')[0].trim();
      var li = document.createElement('li');
      li.className = 'krv-facet-search';
      var input = document.createElement('input');
      input.type = 'search';
      input.placeholder = /μάρκα/i.test(title) ? 'Αναζήτηση μάρκας' : 'Αναζήτηση…';
      input.setAttribute('aria-label', input.placeholder);
      li.appendChild(input);
      list.insertBefore(li, list.firstChild);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
      input.addEventListener('input', function () {
        var q = norm(input.value.trim());
        list.classList.toggle('krv-searching', !!q);
        items.forEach(function (it) { it.classList.toggle('krv-nomatch', !!q && norm(it.textContent).indexOf(q) < 0); });
        var more = d.querySelector('show-more-button');
        if (more) more.hidden = !!q;
      });
    });
  }
  function run() { setup(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 50); }).observe(document.documentElement, { childList: true, subtree: true });
})();
